import viewportHelper from '@kissui/helpers/src/viewport.helpers'
export const renderHeadline = ({ headline = '', is_headline_hidden = false }) => {
    if ((is_headline_hidden && viewportHelper.is.mobile) || !headline) {
        return ''
    }

    return `<p class="cb-text t-sm-400-sl">${headline}</p>`
}
